(() => {

  document.addEventListener('alpine:init', (e) => {
    // Linked Products variant switching
    Alpine.data('LinkedProducts', (type) => ({
      linkedProductsType: '',
      $section: null,
      $products: [],
      products: [],
      init() {
        let am = this;
        am.linkedProductsType = type;

        document.addEventListener('init-LinkedProducts', (e) => {
          if (am.$section) return;

          am.$section = e.target;
          am.$products = [...am.$section.querySelectorAll('[data-linked-product]')];

          // init products on page load
          (async() => {
            let px_products = am.$products.map(($item) => {
              let handle = $item.dataset.linkedProduct;
              return fetch(`/products/${ handle }.js`).then(res => res.json());
            });

            am.products = await Promise.all(px_products);
            am.UpdateLinkedProductUrls();
          })();
        });

        // on variant change, update linked produt urls
        document.addEventListener('variant:change', (e) => {
          am.UpdateLinkedProductUrls(e.detail.variant.options);
        });
      },

      UpdateLinkedProductUrls(current_values) {
        let am = this;

        if (!am.products.length) return;

        am.$products.forEach(($product) => {
          let handle = $product.dataset.linkedProduct;
          let product = am.products.find(p => p.handle == handle);

          if (!product) return;

          if (!current_values) {
            current_values = JSON.parse($product.dataset.current_values);
          }

          let optionIdsToMatch = [1,2,3];
          if (am.linkedProductsType) {
            // exclude option from matching
            optionIdsToMatch = optionIdsToMatch.filter((id) => product.options.map(opt => opt.name).indexOf(am.linkedProductsType) !== (id - 1));
          }

          let valuesToMatch = optionIdsToMatch.map((id) => current_values[(id-1)]);
    
          let matching_variant = product.variants.find((v) => {
            let v_options = optionIdsToMatch.map((id) => v[`option${ id }`]).join('/');
            return v_options == valuesToMatch.join('/')
          });
          if (!matching_variant) return;
          $product.setAttribute('href', `/products/${ handle }?variant=${ matching_variant.id }`);

          // apply soldout class if not available
          $product.querySelector('label').classList.toggle('disabled', !(matching_variant && matching_variant.available));
        });
      }
     }));
  });

})();